var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppConfirmationModal",
    _vm._b(
      {
        attrs: { persistent: "", "max-width": "550px", loading: _vm.loading },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [_vm._v(_vm._s(_vm.header))]
              },
              proxy: true,
            },
            {
              key: "text",
              fn: function () {
                return [
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.title) } }),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-text",
                        [
                          _vm.dataTypeArray
                            ? _vm._t("item-list", function () {
                                return [
                                  _c(
                                    "v-list",
                                    _vm._l(_vm.data, function (item) {
                                      return _c(
                                        "v-list-tile",
                                        { key: item },
                                        [
                                          _c("v-list-tile-content", [
                                            _vm._v(_vm._s(item)),
                                          ]),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ]
                              })
                            : _vm._t("item", function () {
                                return [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.data) +
                                      "\n        "
                                  ),
                                ]
                              }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "actions",
              fn: function () {
                return [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$store.dispatch("app/closeErrorDialog")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "AppConfirmationModal",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }